import classNames from 'classnames';
import moment from 'jalali-moment';
import PostInfo from '../postInfo';
import styles from './roomMessage.module.scss';

type TRoomMessageProps = {
  message: IRoomMessage;
};
const RoomMessage = ({message}: TRoomMessageProps) => {
  return (
    <>
      <div
        className={classNames(
          'd-flex flex-column ',
          !message?.is_author ? 'align-items-end' : '',
        )}
      >
        <div className="text-start">
          {message?.post && (
            <div className="my-2">
              <PostInfo
                title={message?.post?.detail.title}
                image={message?.post?.detail?.image?.image || ''}
              />
            </div>
          )}
        </div>
        <div
          className={classNames(
            styles['room-message'],
            message?.is_author
              ? styles['room-message--seller']
              : styles['room-message--buyer'],
            'p-3 mb-2',
          )}
        >
          <div className="text-end">
            <span>{message?.text}</span>
          </div>
          <div>
            <small className="color-gray-2">
              {moment(message?.created_at)
                .locale('fa')
                .format('HH:mm YYYY/M/D')}
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomMessage;
